import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const TWIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="TW" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#EF0000"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#2E42A5"
          fillRule="evenodd"
          d="M0 0v7h9V0H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#FEFFFF"
          d="m5.286 1.97 1.103-.429-.43 1.104 1.17.18-.924.74.924.74-1.17.18.43 1.104-1.103-.43-.18 1.17-.741-.924-.74.924-.18-1.17-1.104.43.43-1.104-1.171-.18.924-.74-.924-.74 1.17-.18-.429-1.104 1.104.43L3.625.8l.74.924.74-.924.18 1.17Zm-.921.164a1.43 1.43 0 1 0 0 2.861 1.43 1.43 0 0 0 0-2.861Zm0 .286a1.145 1.145 0 1 1 0 2.29 1.145 1.145 0 0 1 0-2.29Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
